module.exports = __webpack_public_path__ + "img/siyoudizhi.512ae686.png";